// extracted by mini-css-extract-plugin
module.exports = {"card":"L_bW","info":"L_P","cardText":"L_bX","imageContainer":"L_bj"};